import { Experience } from "../Models";
import { CareersUrl } from "../config/appConfig";
export const dateConverter = (date: string, withTime?: boolean): string => {
    const options: Intl.DateTimeFormatOptions = {
        month: "short",
        day: "numeric",
        year: "numeric",
    };
    if (withTime) {
        options.hour = "numeric";
        options.minute = "numeric";
        options.hour12 = true;
    }
    const convertedDate = new Date(date).toLocaleDateString("en-US", options);
    return convertedDate;
};


export const getCurrentFormattedDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const hours = String(currentDate.getHours()).padStart(2, '0');
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    const seconds = String(currentDate.getSeconds()).padStart(2, '0');
    const milliseconds = String(currentDate.getMilliseconds()).padStart(3, '0');

    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;

    return formattedDate;
}



//Text editor Formats for Quill
export const formats = [
    'font', 'size',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'script',
    'header', 'blockquote', 'code-block',
    'indent', 'list',
    'direction', 'align',
    'link', 'image', 'video', 'formula',
    '1', '2', '3', '4', '5', '6'
]

//Text editor toolbar for Quill
export const toolbar = [
    [{ 'font': [] }],
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ 'script': 'sub' }, { 'script': 'super' }],
    [{ 'indent': '-1' }, { 'indent': '+1' }],
    ['link', 'image', 'video'],
]



export const debounce = (func: Function, delay: number) => {
    let timeoutId: NodeJS.Timeout;
    return (...args: any) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
};


export async function blobToBase64(blob: any) {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result;
            if (typeof result === 'string') {
                const base64String = result.split(',')[1];
                resolve(base64String);
            } else {
                reject(new Error('Error'));
            }
        };
        reader.onerror = () => {
            reader.abort();
            reject(new Error('Error'));
        };
        reader.readAsDataURL(blob);
    });
}
export function OnBoardRankOrder(experience: Experience) {
    if (experience.department == null || experience.rank == null) { return 11; }
    if (experience.department == "Deck") {
        switch (experience.rank) {
            case "Master": return 1;
            case "Chief Officer": return 2;
            case "Second Officer": return 3;
            case "Third Officer": return 4;
            case "Junior Officer": return 5;
            case "Deck Cadet": return 6;
            case "Bosun": return 7;
            case "AB": return 8;
            case "OS": return 9;
            default: return 11;
        }
    }
    else if (experience.department == "Engine") {
        switch (experience.rank) {
            case "Chief Engineer": return 1;
            case "Second Engineer": return 2;
            case "Third Engineer": return 3;
            case "Fourth Engineer": return 4;
            case "Junior Engineer": return 5;
            case "Engine Cadet": return 6;
            case "Motorman": return 7;
            case "Oiler": return 8;
            case "Wiper": return 9;
            case "Pumpman": return 10;
            default: return 11;
        }
    }
    else if (experience.department == "Rating") {
        switch (experience.rank) {
            case "Fitter": return 1;
            case "Welder": return 2;
            case "ETR": return 3;
            case "Cook": return 4;
            case "Assistant Cook": return 5;
            case "Messman": return 6;
            case "Catering": return 7;
            default: return 11;
        }
    }
    else {
        switch (experience.rank) {
            case "ETO": return 1;
            case "Electrician Cadet": return 2;
            default: return 11;
        }
    }
    return 0;
}



export const careerDomain = `${CareersUrl}/role`;

export const WorkerUrl =
  import.meta.env.VITE_ENVIRONMENT === "PROD"
    ? "https://entntcareersapi.azurewebsites.net/api/Evaluation"
    : import.meta.env.VITE_ENVIRONMENT === "TEST"
      ? "https://testentntcareersapi-ebdzgyenhpdwbjfj.centralindia-01.azurewebsites.net/api/Evaluation"
      : "https://localhost:7154/api/Evaluation";
export const gradeColors = {
    E: {
      bg: "bg-emerald-500",
      hover: "hover:bg-emerald-600",
      text: "text-white",
      border: "border-emerald-600",
      ring: "ring-emerald-200",
      inactive:
        "border-emerald-500/40 hover:border-emerald-500 hover:bg-emerald-50 dark:hover:bg-emerald-950/20",
    },
    P: {
      bg: "bg-blue-500",
      hover: "hover:bg-blue-600",
      text: "text-white",
      border: "border-blue-600",
      ring: "ring-blue-200",
      inactive:
        "border-blue-500/40 hover:border-blue-500 hover:bg-blue-50 dark:hover:bg-blue-950/20",
    },
    F: {
      bg: "bg-red-500",
      hover: "hover:bg-red-600",
      text: "text-white",
      border: "border-red-600",
      ring: "ring-red-200",
      inactive:
        "border-red-500/40 hover:border-red-500 hover:bg-red-50 dark:hover:bg-red-950/20",
    },
    W: {
      bg: "bg-amber-500",
      hover: "hover:bg-amber-600",
      text: "text-white",
      border: "border-amber-600",
      ring: "ring-amber-200",
      inactive:
        "border-amber-500/40 hover:border-amber-500 hover:bg-amber-50 dark:hover:bg-amber-950/20",
    },
  };